import React from "react"
import PropTypes from "prop-types"
import {observer} from "mobx-react"
import AppStore from "./AppStore"
import { HashRouter as Router, Route, Link } from "react-router-dom";
import {Redirect } from "react-router-dom";
import CheckBien from "./CheckBien/CheckBien"
import Signatures from "./Signatures/Signatures"
import CheckPaiement from "./CheckPaiements/CheckPaiement"
import Representants from "./Representants/Representants"
import PayLink from "./CheckPaiements/PayLink"
import 'moment/locale/fr';

@observer
class Routeur extends React.Component {
  constructor(props) {
    super(props);
    AppStore.bien = props.bien
    AppStore.ordremission = props.ordremission
    AppStore.rdv = props.rdv
    this.redirects = this.redirects.bind(this)
    let redirect = ""
    if(props.paiement_en_attente){
      redirect= "PayLink"
    }
    this.state= {
      redirect: redirect
    }

  }
  redirects(){
    if(this.state.redirect.length >1){
      return(<Redirect to={this.state.redirect} />)
    }else{
      return(<div></div>)
    }
  }


  render () {
    if(AppStore.loaded){
      return (
        <React.Fragment>
         <Router>
          <div>

            <Route path="/" exact component={CheckBien} />
            <Route path="/CheckPaiement" exact component={CheckPaiement} />
            <Route path="/Representants" exact component={Representants} />
            <Route path="/PayLink" exact component={PayLink} />
            <Route path="/Signatures" exact component={Signatures} />
          </div>
        {this.redirects()}
        </Router>
        </React.Fragment>
      );
    }else{
      return(
        <React.Fragment>
        <p>Chargement en cours</p>
        </React.Fragment>
        )
    }
  }
}

export default Routeur
